import type { ApiEnv, ApiLocation } from "@/utils/enhance-request";
import { COMPANY_SETTINGS_CONTENT_MAP } from "./company-settings";

export const AMAZEMOVE_ENV = (process.env.AMAZEMOVE_ENV || "development") as ApiEnv;
export const API_LOCATION = (process.env.API_LOCATION || "global") as ApiLocation;

// 暴露当前环境配置，便于部署后排查实际打包参数。
(window as any).__AMAZEMOVE_CONFIG = {
  env: AMAZEMOVE_ENV,
  apiLocation: API_LOCATION,
};
export const IS_DEV = AMAZEMOVE_ENV === "development" || AMAZEMOVE_ENV === "development2";
export const IS_TEST = AMAZEMOVE_ENV === "test";
export const IS_PRE = AMAZEMOVE_ENV === "pre";
export const IS_PROD = AMAZEMOVE_ENV === "production";

// 客服 WebSocket 按接口节点和环境配置，未知地址暂用空值占位。
const WS_PATH_MAP: Record<ApiLocation, Record<ApiEnv, string>> = {
  global: {
    development: "wss://devwebsocket.amazwear.com/websocket/user",
    development2: "",
    test: "wss://testwebsocket.amazwear.com/websocket/user",
    pre: "wss://prewebsocket.amazwear.com/websocket/user",
    production: "wss://websocket.amazwear.com/websocket/user",
  },
  hk: {
    development: "wss://websocket-hk.amazwear.com/websocket/user",
    development2: "wss://websocket-hk.amazwear.com/websocket/user",
    test: "wss://websocket-hk.amazwear.com/websocket/user",
    pre: "wss://websocket-hk.amazwear.com/websocket/user",
    production: "wss://websocket-hk.amazwear.com/websocket/user",
  },
  cn: {
    development: "wss://websocket-dev.apexmove.com/websocket/user",
    development2: "",
    test: "wss://websocket-test.apexmove.com/websocket/user",
    pre: "wss://websocket-pre.apexmove.com/websocket/user",
    production: "wss://websocket.apexmove.com/websocket/user",
  },
  cm: {
    development: "",
    development2: "",
    test: "",
    pre: "",
    production: "",
  },
  rm: {
    development: "wss://devwebsocket.amazwear.com/websocket/user",
    development2: "",
    test: "wss://testwebsocket.amazwear.com/websocket/user",
    pre: "wss://prewebsocket.amazwear.com/websocket/user",
    production: "wss://websocket.amazwear.com/websocket/user",
  },
};
export const WS_PATH = WS_PATH_MAP[API_LOCATION][AMAZEMOVE_ENV];
// export const WS_PATH = `ws://192.168.110.217:8207/websocket/user`;

// 文件上传节点保持原有规则，并通过完整矩阵支持后续品牌扩展。
const FILE_UPLOAD_CODE_MAP: Record<ApiLocation, Record<ApiEnv, string>> = {
  global: {
    development: "aliyun",
    development2: "aliyun",
    test: "aliyun",
    pre: "amazon",
    production: "amazon",
  },
  hk: {
    development: "aliyun",
    development2: "aliyun",
    test: "aliyun",
    pre: "aliyun",
    production: "aliyun",
  },
  cn: {
    development: "aliyun",
    development2: "aliyun",
    test: "aliyun",
    pre: "aliyun",
    production: "aliyun",
  },
  cm: {
    development: "aliyun",
    development2: "aliyun",
    test: "aliyun",
    pre: "aliyun",
    production: "aliyun",
  },
  rm: {
    development: "aliyun",
    development2: "aliyun",
    test: "aliyun",
    pre: "aliyun",
    production: "aliyun",
  },
};
export const FILE_UPLOAD_CODE = FILE_UPLOAD_CODE_MAP[API_LOCATION][AMAZEMOVE_ENV];

export const GLOBAL_KEYS = {
  USER_INFO: "_uis",
  USER_TOKEN: "token",
  TOKEN_EXPIRE: "_te",
  PLAT_THEME: "_pt",
  API_LOCATION: "_al",
};

type CompanySettings = {
  title: string;
  slogan: string;
  copyright: string;
  favicon: string;
  logo: string;
};

// 每个接口节点维护完整品牌配置，页面无需增加环境判断。
const COMPANY_SETTINGS_MAP = {
  global: {
    ...COMPANY_SETTINGS_CONTENT_MAP.global,
    logo: require("@/assets/brand-logo/logo-apexmove.png"),
  },
  hk: {
    ...COMPANY_SETTINGS_CONTENT_MAP.hk,
    logo: require("@/assets/brand-logo/logo-apexmove.png"),
  },
  cn: {
    ...COMPANY_SETTINGS_CONTENT_MAP.cn,
    logo: require("@/assets/brand-logo/logo-liedong.png"),
  },
  cm: {
    ...COMPANY_SETTINGS_CONTENT_MAP.cm,
    logo: require("@/assets/brand-logo/logo-carbinox.png"),
  },
  rm: {
    ...COMPANY_SETTINGS_CONTENT_MAP.rm,
    logo: require("@/assets/brand-logo/logo-ryzemove.png"),
  },
} satisfies Record<ApiLocation, CompanySettings>;

export const COMPANY_SETTINGS = COMPANY_SETTINGS_MAP[API_LOCATION];
